import { render, staticRenderFns } from "./accountInfoManagement.vue?vue&type=template&id=0048b491&scoped=true&"
import script from "./accountInfoManagement.vue?vue&type=script&lang=js&"
export * from "./accountInfoManagement.vue?vue&type=script&lang=js&"
import style0 from "./accountInfoManagement.vue?vue&type=style&index=0&id=0048b491&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048b491",
  null
  
)

export default component.exports